import { http } from '@/utils/http';
import qs from 'qs';

const urlPrefix = 'vote/2022project/q1/2020qglh/controller.php?enews=';

// const getBaseInfo = () => {
//   return http.get(`${baseApiUrl}base-info`);
// };

const getNewsListAsync = ({ classId, page }: any) => {
  return http.get('vote/public/controller.php?enews=news-list', {
    params: {
      classId,
      page,
    },
  });
};

export { getNewsListAsync };
